import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: "#002D55",
    height: 50,
    width: 50
    
  }
}));

const RehabPhaseTracker = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={11}>
            <Typography
              style={{color: "#002D55", marginBottom: 5, marginTop: 5}}
              variant="h5"
            >
              Rehabilitation phase:
            </Typography>
            
            <Typography
              style={{color: "#002D55", marginTop: 15}}
              variant="h4"
            >
              25%
            </Typography>
            <Box mt={1}>
              <LinearProgress
              value={25}
              variant="determinate"
              />
            </Box>
            <Typography
              style={{marginTop: 5, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
              xs={10}
            >
              completed of your rehabilitation phase. <br/><br/>
              Complete and track a minimum of 80 % of your sessions to unlock the next phase of your rehabilitation program. 
            </Typography>
          </Grid>
        </Grid>
     
  );
};

RehabPhaseTracker.propTypes = {
  className: PropTypes.string
};

export default RehabPhaseTracker;